import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "../shared/utils/config.service";
import { StateModel } from "../models/state.model";
import { map } from 'rxjs';

@Injectable()
export class StateService {

    baseUrl: string = '';

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
    };

    getStates() {
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.get(this.baseUrl + '/states', { headers: headers })
            .pipe(map((res: any) => {
                return res;
            }));
    }

    getState(id: number) {
        let headers = new HttpHeaders();
         headers = this.configService.createHeader(headers)

        return this.http.get(this.baseUrl + '/states/' + id, { headers: headers })
            .pipe(map((res: any) => {
                return res;
            }));
    }

    create(state: StateModel) {
        let headers = new HttpHeaders();
         headers = this.configService.createHeader(headers)

        return this.http.post(this.baseUrl + '/states', state, { headers: headers })
            .pipe(map((res: any) => {
                return res;
            }));
    }

    update(state: StateModel) {
        let headers = new HttpHeaders();
         headers = this.configService.createHeader(headers)

        return this.http.put(this.baseUrl + '/states/' + state.id, state, { headers: headers })
            .pipe(map((res: any) => {
                return res;
            }));
    }

    delete(id: number) {
        let headers = new HttpHeaders();
         headers = this.configService.createHeader(headers)

        return this.http.delete(this.baseUrl + '/states/' + id, { headers: headers })
            .pipe(map((res: any) => {
                return res;
            }));
    }
}